import React from "react";

export default function AboutPage() {
  return (
    <>
    <div className="tool-content">
        <h2>About this website</h2>
        <div className="tool-content-about-page">
        <p>
        This website provides aviation preflight calculators for pilots and student pilots.
        Tools include density altitude, crosswind, wind correction angle, and weight and balance.
        </p>

        <p>
        The goal is to provide simple, fast, and reliable tools to support preflight planning
        and flight training.
        </p>
        </div>
            </div>
            </>
  );
}